import React from "react";
import { Route, Routes } from "react-router-dom";
import BeautyshotsPage from "./beautyshots";
import LiftstyleImages from "./LiftstyleImages";
import VideoList from "./videos/VideoList";
import LogosPage from "./logos";
import LandingPage from "./LandingPage";
import CatalogPage from "./catalogs";
import MarketingPage from "./marketing";

function MaterialsIndex() {
  return (
    <Routes>
      <Route path="landing/*" element={<LandingPage />} />
      <Route path="beautyshots/*" element={<BeautyshotsPage />} />
      <Route path="lifestyle-images" element={<LiftstyleImages />} />
      <Route path="logos" element={<LogosPage />} />
      <Route path="videos" element={<VideoList />} />
      <Route path="catalogs" element={<CatalogPage />} />
      <Route path="marketing" element={<MarketingPage />} />
    </Routes>
  );
}

export default MaterialsIndex;
